const l = {
  name: "UpliftOptimize",
  dimensions: { width: 24, height: 24 },
  content: `
<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="#fff" d="M22 2h-5V0h7v7h-2z" style="fill: currentColor;"/><path fill="#fff" d="M18 6h-5V4h7v7h-2z" style="fill: currentColor;"/><path fill="#fff" d="M5.414 20H20v-9h2v11H2V2h11v2H4v14.586L12.586 10H9V8h7v7h-2v-3.586z" style="fill: currentColor;"/></svg>
  `
};
export {
  l as UpliftOptimize
};
